import PropTypes from 'prop-types';
import React from 'react';

const AleloError = '/messages/alelo-error.png';
import './MessageErrorIcon.style.scss';

export const MessageErrorIcon = (props) => {
  return (
    <div className="message-line" data-testid="message-error-icon">
      <div
        className="message-receive-error"
        id={`msg-${props.message.id}`}
        data-aut-test="message-receive-text"
      >
        <div className="message-div-error">
          <span>{props.message.text} </span>
          <img src={AleloError} alt="Ícone de erro da Alelo" />
        </div>
      </div>
    </div>
  );
};

MessageErrorIcon.propTypes = {
  message: PropTypes.object
};
